<template>
    <div>
        <!-- Modal de Limites -->
        <div class="modal fade" id="limiteEstoqueModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Localização / Limites de Saldo em Estoque</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info" v-if="model">{{ model.search }}</div>

                        <az-empty-state v-if="!dados || !dados.length" action="Incluir" :method="incluir" msg="Nenhum limite definido." icon="fa-solid fa-less-than-equal" />

                        <div v-else>
                            <template v-for="(limite, ilx) in dados">
                                <div class="form-row" :key="ilx" v-if="!limite.excluido">
                                    <div class="col col-12 col-md-3">
                                        <template v-if="id_estoque_item">
                                            <az-input
                                                sizing="sm"
                                                :label="ilx ? '' : 'Local de Armazenagem'"
                                                placeholder="Selecione o Local..."
                                                type="select"
                                                service="estoque_locals.index"
                                                optionsData="id_estoque_local"
                                                optionsMode="aql"
                                                required
                                                :validate="validate"
                                                v-model="limite.id_estoque_local">
                                                <template v-slot:button-pre>
                                                    <div class="input-group-prepend">
                                                        <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="limite.excluido = true">
                                                            <i class="fa fa-minus" aria-hidden="true"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </template>

                                        <template v-else-if="id_estoque_local">
                                            <az-input
                                                sizing="sm"
                                                :label="ilx ? '' : 'Item de Estoque'"
                                                placeholder="Selecione o Item..."
                                                type="select"
                                                service="estoque_items.index"
                                                optionsData="id_estoque_item"
                                                optionsMode="aql"
                                                :optionsParms="{ ativos: true }"
                                                required
                                                :validate="validate"
                                                v-model="limite.id_estoque_item">
                                                <template v-slot:button-pre>
                                                    <div class="input-group-prepend">
                                                        <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="limite.excluido = true">
                                                            <i class="fa fa-minus" aria-hidden="true"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </template>
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input 
                                            sizing="sm"
                                            type="number"
                                            placeholder="Não definida..."
                                            :validate="validate"
                                            v-model="limite.in_quantidade_limite" 
                                            :label="ilx ? '' : 'Quantidade Limite'" />
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input 
                                            sizing="sm"
                                            placeholder="Não definida..."
                                            :validate="validate"
                                            v-model="limite.st_local" 
                                            :label="ilx ? '' : 'Localização'" />
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input 
                                            sizing="sm"
                                            placeholder="Observação..."
                                            :validate="validate"
                                            v-model="limite.st_obs" 
                                            :label="ilx ? '' : 'Observação'" />
                                    </div>
                                </div>
                            </template>

                            <button type="button" class="btn btn-primary btn-sm" @click="incluir()">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzInput from '../../shared/forms/AzInput.vue'
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() {
        return { 
            dados: null, 
            id_estoque_item: null,
            id_estoque_local: null,
            model: null, 
            validate: false, 
        }
    },

    components: { 
        AzEmptyState,
        AzInput, 
        AzSubmit, 
    },

    methods: { 
        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'estoque_item_limites',
                func: 'salvar_limites',
                dados: { 
                    lista: this.dados.filter(item => !item.excluido || item.id_estoque_item_limite)
                },
                modal: 'limiteEstoqueModal', 
            });
        },

        incluir () { 
            this.dados.push({
                id_estoque_item_limite: null, 
                id_estoque_item: this.id_estoque_item,
                id_estoque_local: this.id_estoque_local,
                in_quantidade_limite: "",
                excluido: false, 
            });
        },

        abrir (model, id_estoque_item, id_estoque_local) { 
            this.validate = false;
            this.model = model;
            this.id_estoque_item = id_estoque_item;
            this.id_estoque_local = id_estoque_local;

            this.dados = null;

            $('#limiteEstoqueModal').modal('show')

            this.$util.load(this, { 
                service: 'estoque_item_limites',
                func: 'index',
                parms: { 
                    id_estoque_item: id_estoque_item,
                    id_estoque_local: id_estoque_local,
                    cadastro: true, 
                },
                loadTo: res => { 
                    this.dados = res;
                }
            });

        } 

    }

}
</script>
